// src/App.js
import React, { useState, useEffect } from 'react';
import { Container, AppBar, Typography, Grow, Grid, withStyles } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import Posts from './components/Posts/Posts';
import Form from './components/Form/Form';
import { getPosts } from './actions/posts';
import useStyles from './styles';
import titleImage from './images/ModernXP-10-Workstation-Computer-icon.png'; 

// Import the WelcomeOverlay component
import WelcomeOverlay from './components/WelcomeOverlay';

const App = () => {
  const [currentId, setCurrentId] = useState(0);
  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => {
    dispatch(getPosts());
  }, [currentId, dispatch]);

  const TitleTextTypography = withStyles({ /* Title Text*/
    root: {
      color: "rgb(200,200,250)",
      variant: "h3",
      fontSize: '37px',
      fontWeight: '900',
      fontFamily: 'ms sans serif, Tahoma', /* Arial, Verdana, Comic sans ms, Tahoma, Trebuchet ms, Lucida sans, MS sans serif, Times new roman, Geneva, Palatino, Courier, Arial black  */
      //textShadow: '-1px -1px 1px rgb(110,110,250), 1px -1px 1px rgb(110,110,250), -1px 1px 1px rgb(110,110,250), 1px 1px 1px rgb(110,110,250);',
      //className: '{classes.heading}',
    }
  })(Typography);

  const TitleAppBar = withStyles({ /* Title AppBar*/
    root: {
      backgroundColor: 'rgb(70,70,100)'
    }
  })(AppBar);

  const Footer = withStyles({ /* CSS for footer */
    root: {
      backgroundColor: "red",
    }
  })

  

  return (
    <Container maxWidth="lg">

      {/* Render the WelcomeOverlay component */}
      <WelcomeOverlay onClose={() => {}} />
      {/* Render the WelcomeOverlay component */}
      
      <TitleAppBar className={classes.appBar} position="static" color="inherit" backgroundColor="rgb(10,10,10)">
        {/* <Typography className={classes.heading} variant="h3" align="center">Create Posts App</Typography> */} 
        
        <TitleTextTypography>Create Posts App</TitleTextTypography>
        
        <img className={classes.image} src={titleImage} alt="icon" height="65" />
      </TitleAppBar>
      <Grow in>
        <Container>

          <Grid container justify="space-between" alignItems="stretch" spacing={3}>
            <Grid item xs={12} sm={7}>
              <Posts setCurrentId={setCurrentId} />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Form currentId={currentId} setCurrentId={setCurrentId} />
            </Grid>

          </Grid>
        </Container>
      </Grow>
    </Container>
    
  );
};

export default App;

// src/App.js 
